import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconBorderDashed';
/** Renders an SVG icon. */
const SvgBorderDashed = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M15.476 25.986a10 10 0 0 0 1.048 0 1 1 0 0 1 .103 1.997 12 12 0 0 1-1.254 0 1 1 0 1 1 .103-1.997M9.17 24.681a1 1 0 0 1 1.384-.292q.438.285.906.523a1 1 0 0 1-.91 1.781 12 12 0 0 1-1.087-.629 1 1 0 0 1-.293-1.383m12.276-.292a1 1 0 1 1 1.091 1.675q-.525.342-1.088.63a1 1 0 1 1-.909-1.782 10 10 0 0 0 .906-.523M5.742 20.105a1 1 0 0 1 1.346.435q.238.468.523.906a1 1 0 1 1-1.675 1.091 12 12 0 0 1-.63-1.088 1 1 0 0 1 .436-1.345Zm19.17.435a1 1 0 0 1 1.781.91q-.285.56-.629 1.087a1 1 0 0 1-1.675-1.09 10 10 0 0 0 .523-.907M4 16q0-.316.017-.627a1 1 0 1 1 1.997.103 10 10 0 0 0 0 1.048 1 1 0 0 1-1.997.103A12 12 0 0 1 4 16m22 0q0-.263-.014-.524a1 1 0 0 1 1.997-.103 12 12 0 0 1 0 1.254 1 1 0 1 1-1.997-.103Q26 16.264 26 16M5.936 9.463a1 1 0 1 1 1.675 1.09q-.285.44-.523.907a1 1 0 0 1-1.781-.91q.285-.56.629-1.087M24.68 9.17a1 1 0 0 1 1.383.293q.342.526.63 1.088a1 1 0 1 1-1.782.909 10 10 0 0 0-.523-.906 1 1 0 0 1 .292-1.384M10.55 5.307a1 1 0 1 1 .909 1.78q-.468.24-.906.524a1 1 0 1 1-1.091-1.675q.526-.342 1.088-.63Zm9.554.435a1 1 0 0 1 1.344-.435 12 12 0 0 1 1.088.629 1 1 0 1 1-1.09 1.675 10 10 0 0 0-.907-.523 1 1 0 0 1-.435-1.346M16 4q.316 0 .627.017a1 1 0 1 1-.103 1.997 10 10 0 0 0-1.048 0 1 1 0 0 1-.103-1.997Q15.685 4 16 4"
      />
    </svg>
  );
};
SvgBorderDashed.displayName = displayName;
export default SvgBorderDashed;
